export const CollisionGroups = {
  None: 0,
  Ball: 0b1,
  Table: 0b10,
};
